import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { HttpService } from "../../../Services/http.service";

@Component({
    selector: 'app-organization-settings-modal',
    templateUrl: './organization-settings-modal.component.html',
    styleUrls: ['./organization-settings-modal.component.css']
})
export class OrganizationSettingsModalComponent implements OnChanges, OnInit {
    modalReference: NgbModalRef;
    formEdit: UntypedFormGroup;
    settingTypes: any;
    isSaved: boolean = false;
    isSaveError = false;
    @Input() data: any;
    @Output() closeForm = new EventEmitter();
    @ViewChild('classic') public templateRef: TemplateRef<any>;

    ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
        centered: true,
        size: 'md'
    };

    constructor(
        private fb: UntypedFormBuilder,
        public modalService: NgbModal,
        private http: HttpService,
        private translate: TranslateService) {
        this.formEdit = this.fb.group({
            name: [null, Validators.required],
            settingTypes: [null, Validators.required],
            settingsJson: [],
        });
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && this.data) {
            // console.log(this.data);
            this.settingTypes = this.data.settingTypes;
            this.settingTypesControl.setValue(1);
            const json = this.getSettingsById(1);
            this.settingsJsonControl.setValue(json);
        }
    }

    open() {
        this.modalReference = this.modalService.open(this.templateRef, this.ngbModalOptions);
    }

    isJsonFieldValid() {
        const json = this.settingsJsonControl.value;
        if (!json) {
            return true;
        }
        try {
            const jsonObj = JSON.parse(json);
            if (jsonObj && typeof jsonObj === "object" && Object.keys(jsonObj).length > 0) {
                return true;
            }
            return false;
        } catch {
            return false;
        }
    }

    onFocusOutSettingsJsonEvent() {
        if (this.isJsonFieldValid()) {
            const json = this.settingsJsonControl.value;
            const jsonObj = JSON.parse(json);
            const prettyJson = JSON.stringify(jsonObj, undefined, 4);
            this.settingsJsonControl.setValue(prettyJson);
        }
    }

    enableSaveBtn() {
        const settingsTypeId = this.settingTypesControl.value;
        const data = this.getSettingsById(settingsTypeId);
        const hasChanged = data != this.settingsJsonControl.value;
        return hasChanged && this.isJsonFieldValid();
    }

    async saveData() {
        const data = this.settingsJsonControl.value;
        let dataObj: any = null;
        try {
            dataObj = JSON.parse(data);
        } catch {
            // Ignore
        }
        const settingsTypeId = this.settingTypesControl.value;
        const settingsType = this.settingTypes.find((e: any) => e.id = settingsTypeId);
        if (dataObj) {
            try {
                await this.http.updateOrganizationSettings(this.data.customerId, this.data.organizationId, settingsTypeId, dataObj).toPromise();
                this.processSuccessfulUpdate(dataObj, settingsTypeId, settingsType);
            }
            catch (e) {
                console.log(e);
                this.isSaveError = true;
                setTimeout(() => { this.isSaveError = false }, 5000);
            }
        } else {
            try {
                await this.http.deleteOrganizationSettings(this.data.customerId, this.data.organizationId, settingsTypeId).toPromise();
                this.processSuccessfulUpdate(dataObj, settingsTypeId, settingsType);
            }
            catch (e) {
                console.log(e);
                this.isSaveError = true;
                setTimeout(() => { this.isSaveError = false }, 5000);
            }
        }
    }

    processSuccessfulUpdate(dataObj: any, settingsTypeId: number, settingsType: any) {
        console.log('Organization settings were updated successfully');
        const settingsItem = this.data.settings
            .find((e: any) => e.settingsTypeInt == settingsTypeId);
        if (settingsItem) {
            settingsItem.settings = dataObj;
        } else {
            this.data.settings.push({
                settingsType: settingsType.name,
                settingsTypeInt: settingsType.id,
                settings: dataObj
            }
            );
        }
        this.isSaved = true;
        setTimeout(() => { this.isSaved = false }, 5000);
    }

    cancelEdit() {
        this.closeForm.emit();
        this.clearAndCloseModal();
    }

    clearAndCloseModal() {
        // this.formEdit.reset();
        this.modalReference.close();
    }

    get settingsJsonControl() {
        return this.formEdit.controls['settingsJson'];
    }

    get settingTypesControl() {
        return this.formEdit.controls['settingTypes'];
    }

    getSettingsById(id: number) {
        let result = '';
        try {
            const settings = this.data.settings
                .find((e: any) => e.settingsTypeInt == id)
            if (settings) {
                const json = settings.settings;
                if (json) {
                    const jsonStr = JSON.stringify(json, null, 4);
                    result = jsonStr ?? '';
                }
            }
        } catch {
            // Ignore
        }
        return result;
    }

    changeSettingType(id: number) {
        const settings = this.getSettingsById(id);
        this.settingsJsonControl.setValue(settings);
    }
}